/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminEbayCondition
 */
export interface AdminEbayCondition {
    /**
     * 
     * @type {string}
     * @memberof AdminEbayCondition
     */
    name: string;
    /**
     * Value is the Inventory API condition to save, e.g. USED_EXCELLENT.
     * @type {string}
     * @memberof AdminEbayCondition
     */
    value: string;
}

export function AdminEbayConditionFromJSON(json: any): AdminEbayCondition {
    return AdminEbayConditionFromJSONTyped(json, false);
}

export function AdminEbayConditionFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminEbayCondition {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'value': json['value'],
    };
}

export function AdminEbayConditionToJSON(value?: AdminEbayCondition | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'value': value.value,
    };
}

